import { Container, HeaderLogo, HeaderSubMenu, MenuHeader } from "./styles";

import logo from "../../assets/logoInfoSaude2.png";
import logo2 from "../../assets/logoCieges.svg";

import { FlexBox } from "../../styles/global";
import "./styles.scss";
import { Link, useLocation } from "react-router-dom";
import { useDataContext } from "../../context/DataContext";
import TimeDisplay from "../../utils/timeConvert";

const Header = () => {
  const { data5 } = useDataContext();
  const location = useLocation();

  return (
    <Container>
      <MenuHeader></MenuHeader>

      <HeaderLogo>
        <img src={logo} alt="imagem" />
      </HeaderLogo>
      <FlexBox
        width="100%"
        align="center"
        justify="center"
        direction="column"
        gap="9px"
      >
        <h1>Portas do Serviço Hospitalar de Emergência (SHE)</h1>
        <HeaderSubMenu width="auto" gap="63px">
          {location.pathname === "/card" ? (
            <Link to="/">
              <h2>Mapa</h2>
            </Link>
          ) : (
            <Link to="/card">
              <h2>Detalhado</h2>
            </Link>
          )}
        </HeaderSubMenu>
      </FlexBox>

      <HeaderLogo>
        <img src={logo2} alt="imagem" />
        <FlexBox justify="space-between" direction="column" gap="2px">
          <FlexBox justify="space-between">
            <p>
              Fonte:
              <span>TrakCare</span>
            </p>
            <p>
              Última Atualização:
              <span>{data5 && TimeDisplay(data5)}</span>
            </p>
          </FlexBox>
          <p style={{ textAlign: "center", fontSize: "0.8rem" }}>
            (atualização a cada 5 minutos)
          </p>
        </FlexBox>
      </HeaderLogo>
    </Container>
  );
};

export default Header;
